import { Pagination, PaginationRenderItemParams } from '@mui/material';
import PaginationItem from '@mui/material/PaginationItem';

type OwnProps = {
  currentPage: number;
  totalPages: number;
  changePage: (newPage: number) => void;
};

export const CustomServerPagination = ({ currentPage, totalPages, changePage }: OwnProps) => {
  return (
    <Pagination
      color="primary"
      variant="soft"
      page={currentPage}
      shape="rounded"
      count={totalPages}
      onChange={(_event, page) => changePage(page)}
      sx={{
        mt: 2,
        mb: 2,
        '& > .MuiPagination-ul': {
          justifyContent: 'center',
        },
      }}
      renderItem={(item: PaginationRenderItemParams) => (
        <PaginationItem
          page={item.page}
          type={item.type}
          selected={item.selected}
          disabled={item.disabled}
          onClick={item.onClick}
          data-test-id={item.type === 'page' ? `page-${item.page}` : `button-${item.type}`}
        />
      )}
    />
  );
};
